import { fetchUtils } from "react-admin";
import {
    DataProvider,
    GetListParams,
    Identifier,
} from 'react-admin';
import simpleRestProvider from 'ra-data-simple-rest';
import { rednaxelCookie, getIsInitialized, rednaxelAPI } from './authProvider';
import { getActivityLog } from '../commons/activity';

import Cookies from 'js-cookie'
import { jwtDecode } from "jwt-decode";


const fetchJson = (url: string, options: fetchUtils.Options = {}) => {
    const customHeaders = (options.headers ||
        new Headers({
            Accept: 'application/json',
        })) as Headers;

    const auth = Cookies.get(rednaxelCookie) ?? '';
    const decoded = jwtDecode(auth);

    customHeaders.set('Authorization', 'Bearer ' + decoded.jti);
    options.headers = customHeaders;
    return fetchUtils.fetchJson(url, options);
}

export const dataProvider = simpleRestProvider(rednaxelAPI, fetchJson);

export type CrmDataProvider = typeof dataProviderWithCustomMethods;

const dataProviderWithCustomMethods = {
    ...dataProvider,
    async getList(resource: string, params: GetListParams) {
        return dataProvider.getList(resource, params);
    },
    async getOne(resource: string, params: any) {
        return dataProvider.getOne(resource, params);
    },
    async isInitialized() {
        return getIsInitialized();
    },
    async updatePassword(id: Identifier) {
        // implementar
        return true;
    }
} satisfies DataProvider;